import { Location } from './location';
export interface Address {
  id?: string;
  gmID: string;
  placeID: string;
  name?: string;
  icon?: string;
  displayAddress?: string;
  postalCode?: number;
  streetNumber?: number;
  streetName?: string;
  sublocality?: string;
  locality?: {
    short?: string;
    long?: string;
  };
  city?: {
    short?: string;
    long?: string;
  };
  state?: {
    short?: string;
    long?: string;
  };
  country?: {
    short?: string;
    long?: string;
  };
  vicinity?: string;
  url?: string;
  geoLocation?: Location;
  subpremise?: string;
}

export function GetPlaceResult(place: any): Address {

  const address: Address = {
    gmID: place.id,
    icon: place.icon,
    url: place.url,
    placeID: place.place_id,
    displayAddress: place.formatted_address,
    name: place.name,
    vicinity: place.vicinity,
    locality: {},
    city: {},
    state: {},
    country: {},
    geoLocation: { latitude: -1, longitude: -1 },
  };

  if (place.geometry && place.geometry.location) {
    address.geoLocation.latitude = place.geometry.location.lat();
    address.geoLocation.longitude = place.geometry.location.lng();
  }

  place.address_components.forEach(value => {
    if (value.types.indexOf('street_number') > -1) {
      address.streetNumber = value.short_name;
    }
    if (value.types.indexOf('route') > -1) {
      address.streetName = value.long_name;
    }
    if (value.types.indexOf('postal_code') > -1) {
      address.postalCode = Number(value.short_name);
    }
    if (value.types.indexOf('sublocality') > -1) {
      address.sublocality = value.long_name;
    }
    if (value.types.indexOf('locality') > -1) {
      address.locality.long = value.long_name;
      address.locality.short = value.short_name;
    }
    if (value.types.indexOf('administrative_area_level_1') > -1) {
      address.state.long = value.long_name;
      address.state.short = value.short_name;
    }
    if (value.types.indexOf('administrative_area_level_2') > -1) {
      address.city.long = value.long_name;
      address.city.short = value.short_name;
    }
    if (value.types.indexOf('administrative_area_level_3') > -1) {
      address.locality.short = value.short_name;
    }
    if (value.types.indexOf('country') > -1) {
      address.country.long = value.long_name;
      address.country.short = value.short_name;
    }
    if (value.types.indexOf('subpremise') > -1) {
      address.subpremise = value.short_name;
    }
  });
  return address;
}
